/**
 * GroupsAgGridHook
 *
 * Grid for /admin/merchants/groups. Backed by MerchantCore.Groups, which
 * used to load every group and every brand into memory on mount — this
 * uses AG Grid's server-side row model so groups page over the LiveView
 * socket.
 *
 * Deliberately NOT using AG Grid's masterDetail feature here: this app's
 * vendored ag-grid-enterprise.js and ag-grid-community.min.js are two
 * separately built bundles that don't share the same internal Column
 * classes, and any enterprise feature that injects a synthetic managed
 * column (masterDetail's expand column, treeData's auto-group column)
 * renders broken/garbled instead of the real grid — confirmed live, not
 * a guess. A row click instead pushes the group id to the LiveView, which
 * renders that group's brands as a plain panel below the grid.
 */

import { mountServerSideGrid } from "../base/ServerSideAgGridHook";

const PAGE_SIZE = 25;

const pill = (bg, color, label) =>
  `<span style="background:${bg};color:${color};padding:1px 8px;border-radius:9999px;font-size:11px;font-weight:600;white-space:nowrap;">${label}</span>`;

const statusCell = (params) => {
  if (!params.value) return "";
  return pill("var(--ag-chip-background-color)", "var(--ag-data-color)", params.value);
};

const brandCountCell = (params) => {
  if (params.value === undefined || params.value === null) return "";
  return `<span style="font-weight:600;">${params.value}</span>`;
};

const GroupsAgGridHook = {
  mounted() {
    if (!window.agGrid || !window.agGrid.createGrid) {
      console.error("GroupsAgGridHook: agGrid not found on window");
      return;
    }

    const columnDefs = [
      { headerName: "Group", field: "name", flex: 1.2, minWidth: 160 },
      { headerName: "Code", field: "code", width: 140 },
      { headerName: "Status", field: "status", width: 120, cellRenderer: statusCell },
      { headerName: "MCC", field: "mcc_code", width: 120 },
      { headerName: "Currency", field: "settlement_currency", width: 120 },
      { headerName: "Members", field: "brand_count", width: 110, sortable: false, cellRenderer: brandCountCell },
    ];

    this.gridApi = mountServerSideGrid(this, {
      columnDefs,
      rowsEvent: "groups:rows",
      refreshEvent: "groups:refresh",
      pageSize: PAGE_SIZE,
      gridOptions: {
        onRowClicked: (params) => {
          if (params.data) this.pushEvent("groups:select", { group_id: params.data.id });
        },
      },
    });
  },

  destroyed() {
    if (this.gridApi) {
      this.gridApi.destroy();
      this.gridApi = null;
    }
  },
};

export default GroupsAgGridHook;
